import { ActionCreatorWithPayload } from '@reduxjs/toolkit';
import { useState, useEffect } from 'react';
import { useAppDispatch } from '../../configuration/setup/hooks';
import fetchHelper from '../fetchHelper';

type UseFetchRequest<T> = {
    url: string;
    method?: 'GET' | 'POST' | 'PUT' | 'DELETE';
    reduxAction?: ActionCreatorWithPayload<T>;
};

type UseFetchResponse<T> = {
    data?: T | null;
    error: string | null;
    isLoading: boolean;
};

export const useFetch = <T>({ url, method = 'GET', reduxAction }: UseFetchRequest<T>): UseFetchResponse<T> => {
    const [data, setData] = useState<T | null>();
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    const dispatch = useAppDispatch();

    const fetchData = async () => {
        setIsLoading(true);

        try {
            const response = await fetchHelper<T>(url, { method });

            setIsLoading(false);
            setErrorMessage(null);
            setData(response.data);

            if (response.data && reduxAction) {
                dispatch(reduxAction(response.data));
            }
        } catch (error) {
            setErrorMessage(String(error));
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
    }, [url]);

    return { data, isLoading, error: errorMessage };
};
